import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { apiJson } from "../utils/api";
import { persistWechatLogin } from "../components/WeChatLoginButton";
import { getSafeInternalPath } from "../utils/safeNavigate";

export default function WeChatCallbackPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    const ticket = searchParams.get("ticket");
    const redirect =
      getSafeInternalPath(searchParams.get("redirect") || "") || "/love-map";
    if (!ticket) {
      setError("缺少登录凭证");
      return undefined;
    }
    let cancelled = false;
    (async () => {
      try {
        const { res, data } = await apiJson("/api/auth/wechat/exchange", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ ticket }),
        });
        if (!res.ok) throw new Error(data?.detail || "登录失败");
        if (cancelled) return;
        persistWechatLogin(data);
        navigate(data.redirect || redirect, { replace: true });
        window.location.reload();
      } catch (e) {
        if (!cancelled) setError(e.message || "登录失败");
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 to-purple-50 flex flex-col">
      <Header />
      <main className="flex-1 flex items-center justify-center px-4">
        <div className="bg-white rounded-2xl shadow p-8 max-w-sm w-full text-center space-y-3">
          <h1 className="text-lg font-bold text-gray-800">微信登录</h1>
          {error ? (
            <>
              <p className="text-sm text-red-500">{error}</p>
              <button
                type="button"
                onClick={() => navigate("/login")}
                className="text-sm text-rose-600"
              >
                返回登录页
              </button>
            </>
          ) : (
            <p className="text-sm text-gray-500">正在完成登录，请稍候…</p>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
